import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import useRepeater from 'researcher/hooks/use-repeater';
import Link from 'shared/components/Link';
import Paginator from 'shared/components/Paginator';
import { NUMBER_OF_SECONDS_BETWEEN_UPDATES } from '../constants';
import DigitalEditStatus from './DigitalEditStatus';
import DigitalEditingActions from './DigitalEditingActions';
var DigitalEditResults = function DigitalEditResults(_ref) {
  var archiveDigitalEdit = _ref.archiveDigitalEdit,
    digitalEdits = _ref.digitalEdits,
    getDownloadUrl = _ref.getDownloadUrl,
    pagination = _ref.pagination,
    paginationUrl = _ref.paginationUrl,
    pathname = _ref.pathname,
    searchDigitalEdits = _ref.searchDigitalEdits,
    status = _ref.status,
    updateDisplayedDigitalEdits = _ref.updateDisplayedDigitalEdits;
  var downloading = function downloading(digitalEdit) {
    return status.retrievingDownload && status.downloadingFiles.indexOf(digitalEdit.identity) >= 0;
  };
  var inProgressDigitalEditIdentities = digitalEdits.filter(function (digitalEdit) {
    return digitalEdit.processing;
  }).map(function (digitalEdit) {
    return digitalEdit.identity;
  });
  var _useRepeater = useRepeater({
      fn: function fn() {
        return updateDisplayedDigitalEdits(inProgressDigitalEditIdentities);
      },
      numberOfSecondsBetweenCalls: NUMBER_OF_SECONDS_BETWEEN_UPDATES
    }),
    startUpdating = _useRepeater.start,
    stopUpdating = _useRepeater.stop;
  useEffect(function () {
    if (inProgressDigitalEditIdentities.length > 0) {
      startUpdating();
    } else {
      stopUpdating();
    }
  }, [inProgressDigitalEditIdentities.length]);
  useEffect(function () {
    return function () {
      return stopUpdating();
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-3"
  }, digitalEdits.map(function (digitalEdit) {
    return /*#__PURE__*/React.createElement("div", {
      className: "digital-edit clearfix p-3",
      key: digitalEdit.identity
    }, /*#__PURE__*/React.createElement("div", {
      className: "float-start progress-circle"
    }, /*#__PURE__*/React.createElement(DigitalEditStatus, {
      digitalEdit: digitalEdit
    })), /*#__PURE__*/React.createElement("div", {
      className: "content ps-3 pt-2 mb-0"
    }, /*#__PURE__*/React.createElement("h5", {
      className: "text-truncate"
    }, digitalEdit.completed ? /*#__PURE__*/React.createElement(Link, {
      to: {
        state: {
          pathname: pathname
        },
        pathname: "/researcher/digital-editing/details/".concat(digitalEdit.identity)
      }
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      className: "me-2 align-middle",
      icon: "fa-solid fa-file-lines"
    }), digitalEdit.file.name) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      className: "me-2 align-middle",
      icon: "fa-solid fa-file-lines"
    }), digitalEdit.file.name)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-muted mt-1 text-small"
    }, /*#__PURE__*/React.createElement(DigitalEditingActions, {
      archiveDigitalEdit: archiveDigitalEdit,
      digitalEdit: digitalEdit,
      downloading: downloading,
      getDownloadUrl: getDownloadUrl,
      pathname: pathname
    })))));
  }), /*#__PURE__*/React.createElement(Paginator, {
    className: "pt-3",
    pagination: pagination,
    url: paginationUrl,
    onPageChange: function onPageChange(page) {
      return searchDigitalEdits({
        page: page
      }).then(function () {
        return window.scrollTo(0, 0);
      });
    },
    updating: status.searchBusy
  }));
};
export default DigitalEditResults;